import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PaymentData } from '../../types/company.types';
import { useAppQuery } from '../use-app-query.hook';

export const usePaymentDetails = ({
  companyId,
  enabled = true,
}: {
  companyId: string;
  enabled?: boolean;
}) => {
  const queryClient = useQueryClient();
  const { data: paymentData, isLoading } = useAppQuery<PaymentData>({
    queryKey: [QueryKey.GET_PAYMENT_DATA, companyId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'payment-details'],
      }),
    enabled: !!companyId && enabled,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PAYMENT_DATA] });
  }, [queryClient]);
  return { paymentData, invalidateQuery, isLoading };
};
